import { useEffect, useState } from "react";
import { Instagram, Youtube, Facebook, Linkedin, GripVertical } from "lucide-react";
import { api } from "@/lib/api";

const ICONS = [
  { key: "instagram", Icon: Instagram, label: "Instagram" },
  { key: "youtube", Icon: Youtube, label: "YouTube" },
  { key: "facebook", Icon: Facebook, label: "Facebook" },
  { key: "linkedin", Icon: Linkedin, label: "LinkedIn" },
];

/**
 * Persistent, app-wide vertical social rail. Sits mostly off-screen at the
 * left edge (only a small grip visible) and slides fully into view when the
 * cursor enters its area. Links come from the admin-editable brand profile.
 */
export default function SocialRail() {
  const [links, setLinks] = useState({});

  useEffect(() => {
    api.get("/brand-profile").then(r => setLinks(r.data?.social_links || {})).catch(() => {});
  }, []);

  const visible = ICONS.filter(({ key }) => links[key]);
  if (visible.length === 0) return null;

  return (
    <div className="social-rail-track" data-testid="social-rail">
      <div className="social-rail-pill">
        <div className="social-rail-icons">
          {visible.map(({ key, Icon, label }) => (
            <a key={key} href={links[key]} target="_blank" rel="noreferrer"
               aria-label={label} data-testid={`social-link-${key}`}>
              <Icon className="w-4 h-4" />
            </a>
          ))}
        </div>
        <div className="social-rail-grip"><GripVertical className="w-3.5 h-3.5" /></div>
      </div>
    </div>
  );
}
